import React from 'react';

import styled from 'styled-components';

import { useFeatureDisclaimers } from 'hooks/use-feature-disclaimers';

import Picture from './picture';
import { IHeroPicture } from './types';

const Disclaimer = styled.span`
  font-size: 0.75rem;
  color: ${Styles.color.black};
  text-align: center;
`;

const Hero: React.FC<IHeroPicture> = props => {
  const { featureDisclaimers } = useFeatureDisclaimers();
  const { images: imagesDisclaimer } = featureDisclaimers || {};

  return (
    <>
      <Picture image={props.image} alt={props.alt} />
      <Disclaimer>{imagesDisclaimer?.locale}</Disclaimer>
    </>
  );
};

export default Hero;
